import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { ssListItem } from 'app/components/global';
import minimumDepartmentResources from './departmentResources';
import departmentProcedures from './departmentProcedures';
import hardwareAndSchematics from './hardwareAndSchematics';
import facilities from './facilities';
import itCoreProcedures from './itCoreProcedures';
import successionPlanning from './successionPlanning';
import externalResources from './externalResources';
import emergencyPlan from './emergencyPlan';
import pandemicPlan from './pandemicPlan';
import controller from './risk-management.controller';
import directive from './risk-management.directive';


export default angular.module('app.components.advisory.bcp.riskManagement', [
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
  ssListItem,
  minimumDepartmentResources,
  departmentProcedures,
  facilities,
  itCoreProcedures,
  successionPlanning,
  externalResources,
  emergencyPlan,
  pandemicPlan,
  hardwareAndSchematics,
])
  .directive('bcpRiskManagement', directive)
  .controller('RiskManagementController', controller)
  .name;

console.log('app.components.advisory.bcp.riskManagement created');
